import React from 'react'
import cn from 'classnames'
import { makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { styles } from './styles'

const useStyles = makeStyles(() => styles)

export const ConfirmDialogV2 = ({
  title,
  contentText,
  leftButtonLable,
  rightButtonLable,
  onAgree,
  onDisagree,
  className = '',
}) => {
  const classes = useStyles()
  return (
    <div className={cn(classes.container, className)}>
      <div className={classes.card} cypress_id={'modalContainer'}>
        <div className={classes.content}>
          <div className={classes.closeContainer}>
            <div className={classes.close} onClick={onDisagree}>
              <CloseIcon />
            </div>
          </div>
          <div className={classes.title} cypress_id={'modalTitle'}>
            {title}
          </div>
          <div className={classes.message}>{contentText}</div>
          <div className={classes.buttonsWrapper}>
            <div
              className={classes.cancel}
              onClick={onDisagree}
              cypress_id={'cancelBtnInModal'}
            >
              {leftButtonLable}
            </div>
            <div
              className={classes.confirm}
              onClick={onAgree}
              cypress_id={'deleteBtnInModal'}
            >
              {rightButtonLable}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
